// Trips page — dispatch attestation + manifest capture
// Each trip creates a sealed Trip Wallet ($1 receipt)

import { getAllTrips, addTrip, getAllVehicles, getAllTrailers, getAllDrivers } from '../stores/db.js';
import { showToast } from '../app.js';

export async function renderTrips(container, ctx) {
  const trips = await getAllTrips(20);
  const vehicles = await getAllVehicles(ctx.carrierDOT);
  const trailers = await getAllTrailers(ctx.carrierDOT);
  const drivers = await getAllDrivers(ctx.carrierDOT);

  container.innerHTML = `
    <div class="page">
      <div class="page-title">Trips</div>

      <button class="btn btn-primary" onclick="window._newTrip()" style="margin-bottom: 16px;">+ New Dispatch</button>

      <!-- New Trip Form -->
      <div id="new-trip-form" style="display: none;">
        <div class="card" style="border-color: var(--accent);">
          <div class="card-title" style="margin-bottom: 12px;">New Dispatch</div>

          <div class="input-group">
            <label>Truck</label>
            <select id="trip-vehicle">
              <option value="">Select truck...</option>
              ${vehicles.map(v => `<option value="${v.vin}">${v.year || ''} ${v.make || ''} ${v.model || ''} (${v.vin.slice(-6)})</option>`).join('')}
            </select>
          </div>

          <div class="input-group">
            <label>Trailer (optional)</label>
            <select id="trip-trailer">
              <option value="">No trailer</option>
              ${trailers.map(t => `<option value="${t.id}">${t.type || 'Trailer'} ${t.unitNumber || t.serialNumber || ''}</option>`).join('')}
            </select>
          </div>

          <div class="input-group">
            <label>Driver</label>
            <select id="trip-driver">
              <option value="">Select driver...</option>
              ${ctx.role === 'driver' || ctx.role === 'owner-operator'
                ? `<option value="self" selected>${ctx.userName}</option>`
                : drivers.map(d => `<option value="${d.id}">${d.name}</option>`).join('')
              }
            </select>
          </div>

          <div class="input-group">
            <label>Origin</label>
            <input type="text" id="trip-origin" placeholder="Pickup address or location">
          </div>

          <div class="input-group">
            <label>Destination</label>
            <input type="text" id="trip-dest" placeholder="Delivery address or location">
          </div>

          <div class="input-group">
            <label>Load Description</label>
            <input type="text" id="trip-cargo" placeholder="e.g. 22 tons crushed limestone">
          </div>

          <div class="input-group">
            <label>Load/Reference Number</label>
            <input type="text" id="trip-ref" placeholder="e.g. LOAD-8847">
          </div>

          <div class="capture-row">
            <div class="capture-btn" onclick="window._captureManifest()">
              📄 Photo Manifest / BOL
            </div>
          </div>
          <div id="manifest-preview"></div>

          <div style="display: flex; gap: 8px; margin-top: 12px;">
            <button class="btn btn-primary" onclick="window._createTrip()">Create Trip Wallet</button>
            <button class="btn btn-secondary" onclick="document.getElementById('new-trip-form').style.display='none'">Cancel</button>
          </div>
        </div>
      </div>

      <!-- Trip History -->
      <div id="trip-list">
        ${trips.length === 0
          ? '<div class="card"><p style="color: #888; text-align: center;">No trips yet. Create a dispatch to generate a Trip Wallet.</p></div>'
          : trips.map(t => `
            <div class="card">
              <div style="display: flex; justify-content: space-between;">
                <div>
                  <div class="card-title">${t.loadRef || 'Trip'} ${t.origin ? '→ ' + t.destination : ''}</div>
                  <div class="card-meta">${new Date(t.timestamp).toLocaleString()}</div>
                  <div class="card-meta">${t.cargo || ''}</div>
                </div>
                <div style="text-align: right;">
                  <span class="badge ${t.walletCreated ? 'badge-pass' : 'badge-pending'}">
                    ${t.walletCreated ? 'Sealed' : 'Draft'}
                  </span>
                </div>
              </div>
              ${t.walletLink ? `<div style="margin-top: 8px;"><a href="${t.walletLink}" style="font-size: 0.8em;">View Trip Wallet →</a></div>` : ''}
            </div>
          `).join('')
        }
      </div>
    </div>
  `;

  let manifestPhoto = null;

  window._newTrip = () => {
    document.getElementById('new-trip-form').style.display = 'block';
  };

  window._captureManifest = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.capture = 'environment';
    input.onchange = (e) => {
      const file = e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = () => {
        manifestPhoto = reader.result;
        document.getElementById('manifest-preview').innerHTML = `
          <img src="${reader.result}" style="width: 100%; max-height: 200px; object-fit: cover; border-radius: 6px; margin-top: 8px; border: 1px solid var(--border);">
          <div style="font-size: 0.8em; color: var(--pass); margin-top: 4px;">Manifest captured</div>
        `;
        showToast('Manifest photo captured');
      };
      reader.readAsDataURL(file);
    };
    input.click();
  };

  window._createTrip = async () => {
    const vehicleId = document.getElementById('trip-vehicle').value;
    const trailerId = document.getElementById('trip-trailer').value;
    const driverId = document.getElementById('trip-driver').value;
    const origin = document.getElementById('trip-origin').value.trim();
    const destination = document.getElementById('trip-dest').value.trim();
    const cargo = document.getElementById('trip-cargo').value.trim();
    const loadRef = document.getElementById('trip-ref').value.trim();

    if (!vehicleId) { showToast('Select a truck'); return; }

    const trip = {
      vehicleId,
      trailerId: trailerId || null,
      driverId: driverId || null,
      driverName: ctx.userName,
      origin,
      destination,
      cargo,
      loadRef,
      carrierDOT: ctx.carrierDOT,
      manifestPhoto: manifestPhoto ? 'captured' : null,
      walletCreated: false,
      walletLink: null,
      // TODO: Add weather, route risk, carrier vetting link
    };

    await addTrip(trip);
    showToast('Trip created — wallet sealing coming soon');
    document.getElementById('new-trip-form').style.display = 'none';
    renderTrips(container, ctx);
  };
}
